var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('header-app'),_c('complejo-home',{attrs:{"complejo":_vm.complejo,"colorMenu":_vm.colorMenu,"items1":_vm.items1,"items2":_vm.items2,"items3":_vm.items3}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }